<template>
  <main class="dashboard">
    <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">{{ current_page.name }}</h1>
    </div>
    <div class="text" v-html="current_page.description"></div>

      <div class="table-flex-responsive">
        <div class="row header">
          <div class="col-1"> №</div>
          <div class="col">Дата запуска</div>
          <div class="col">Дата завершения</div>
          <div class="col">Текст</div>
          <div class="col">Изображение или видео</div>
          <div class="col">Дата добавления / изменения</div>
          <div class="col"></div>
        </div>
        <template v-for="(object, index) in objects">
          <div class="row line">

            <div class="col-1 number">
              <div class="sub-head">№</div>
              {{ (index + 1) + ((page - 1) * size) }}
            </div>
            <div class="col sub-head">Дата запуска</div>
            <div class="col">
              <template v-if="object.edit">
                <label class="d-none">Дата запуска</label>
                <div :class="'date-choice'+(object.date_start_error?'form-group--error':'')">

                  <date-picker @dp-show="clickDate($event)" class="date-picker"
                               @dp-change="object.date_start_error = false"
                               readonly style="width: 150px; height: 31px;" v-model="object.date_start"
                               ref="start_date" :config="date_options"></date-picker>
                  <!--<i class="bi bi-calendar"></i>-->
                </div>
                <div class="error" v-if="object.date_start_error">{{ object.date_start_error }}</div>
              </template>
              <template v-else>
                {{ object.date_start }}
              </template>
            </div>
            <div class="col sub-head">Дата завершения</div>
            <div class="col">
              <template v-if="object.edit">
                <div :class="'date-choice'+(object.date_end_error?'form-group--error':'')">
                  <date-picker
                      v-model="object.date_end"
                      locale="ru"
                      format="dd.MM.yyyy"
                      model-type="yyyy-MM-dd"
                      auto-apply
                      :enable-time-picker="false">
                  </date-picker>
                </div>
                <div class="error" v-if="object.date_end_error">{{ object.date_end_error }}</div>
              </template>
              <template v-else>
                {{ object.date_end }}
              </template>
            </div>
            <div class="col sub-head">Текст</div>
            <div class="col">
              <template v-if="object.edit">
                <div :class="object.text_error?'form-group--error':''">
                      <textarea v-focus class="form-control" name="" cols="50" rows="20"
                                v-on:keyup="object.text_error = false"
                                v-model="object.text"></textarea>
                </div>
                <div class="error" v-if="object.text_error">{{ object.text_error }}</div>
              </template>
              <template v-else>
                {{ object.text }}
              </template>
            </div>
            <div class="col sub-head">Изображение или видео</div>
            <div class="col">
              <template v-if="object.edit">
                <div :class="'d-flex no-wrap'+(object.text_error?' form-group--error':'')">
                  <input :id="`media-${index}`" :ref="`media-${index}`" type="file" class="d-none"
                         v-on:change="setFile('media', index, object);object.media_error = false"/>
                  <input readonly type="text" :ref="`media_name-${index}`" class="file-name-upload"
                         v-model="object.media"/>
                  <label class="btn btn-primary" :for="`media-${index}`" title="Загрузить"><i
                      class="bi bi-file-arrow-up"></i></label>
                  <label class="btn btn-danger" v-if="object.media" v-on:click="object.media = ''"
                         title="Удалить"><i class="bi bi-x"></i></label>
                </div>
                <div class="error" v-if="object.text_error">{{ object.text_error }}</div>
              </template>
              <template v-else>
                {{ object.media }}
              </template>
            </div>
            <div class="col sub-head">Дата добавления / изменения</div>
            <div class="col">
              {{ object.date }}
            </div>
            <div class="col sub-head"></div>
            <div class="col">
              <a href="" v-if="!object.edit" v-on:click.prevent="object.edit = true;"
                 class="no-wrap"><i class="bi bi-pencil"></i>
                <small>редактировать</small>
              </a>
              <template v-else>
                <a href="" class="text-success ms-sm-2 no-wrap" v-on:click.prevent="saveNote(object)"><i
                    class="bi bi-check-circle"></i>
                  <small>Сохранить</small>
                </a> <br>
                <a href="" class="text-danger ms-sm-2 no-wrap" v-on:click.prevent="endEdit(object)"><i
                    class="bi bi-x-circle"></i>
                  <small>Отмена</small>
                </a>
              </template>
            </div>


          </div>
        </template>
        <div v-if="!objects.length" class="row">
          <div class="col-12 text-center">
            Не добавлено ни одной записи
          </div>
        </div>
        <div v-if="objects.length < max_length">
          <div>
            <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
          </div>
        </div>
      </div>

      <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>

  </main>
</template>

<script>
import dataMixin from './mixins.js';

export default {
  name: 'TargetsService',
  mixins: [dataMixin],
  data() {
    return {
      name: 'targets',
      validate: {
        'date_start': {},
        'date_end': {},
        'text': {
          func: function (object) {
            return !object.text && !object.media
          }, error: 'Одно из полей должно быть заполнено'
        }

      },
      empty: {date_start: '', date_end: '', date: '', edit: true, text: '', media: ''}
    }
  }
}

</script>


<style>
textarea {
  min-width: 380px;
}
</style>
